import { Component, Injector, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { MOTIVO_CANCELAMENTO, MultaCancelamento, SolicitacaoCancelamentoGarantia } from 'src/app/model/solicitacao-cancelamento-garantia.model';
import Utils from 'src/app/shared/fgi-utils';
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoCancelamentoGarantiaService } from 'src/app/shared/services/solicitacao-cancelamento-garantia.service';
import { RecuperacaoCreditoService } from '../../recuperacao/recuperacao-credito/recuperacao-credito.service';
import moment from "moment";
import { ResultadoCalculoValorHonradoARecuperar } from "src/app/model/recuperacao-credito.model";
import { Observable } from "rxjs";
import { DataSistemaService } from "src/app/shared/services/data-sistema.service";
import { ModalidadeService } from "src/app/shared/services/modalidade.service";

type Acao = 'aprovar' | 'reprovar' | 'reverter'

@Component({
    selector: 'app-cancelamento-detalhe',
    templateUrl: './cancelamento-detalhe.component.html',
    styleUrls: ['./cancelamento-detalhe.component.scss'],
    standalone: false
})
export class CancelamentoDetalheComponent extends BaseEntityComponent<SolicitacaoCancelamentoGarantia> implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private idSolicitacaoCancelamento: number;
    public solicitacaoCancelamento: SolicitacaoCancelamentoGarantia;
    public permissaoLinkN03: false;
    public podeAprovarOuReprovar = false;
    public ocorrencias: OcorrenciaValidacaoVO[] = [];
    public podeCancelar = false;
    public valorBaseCalculoMulta: number = 0.00;
    public valorPercentualMulta: number = 0.00;
    public valorHonradoARecuperar:number = 0.00;
    public valorHistoricoHonra: number = 0.00;
    
    public acaoEscolhida: Acao;

    public radioBaseCalculo: string;

    @ViewChild('reprovacao') mensagemReprovacao: TemplateRef<any>;
    private motivoReprovacao: string;
    
    @ViewChild('reversao') mensagemReversao: TemplateRef<any>;
    private motivoReversao: string;

    @ViewChild('aprovacao') mensagemAprovacao: TemplateRef<any>;


    @ViewChild('botoesDeAcao') botoesDeAcao: TemplateRef<any>;

    private dataCorrente: Date;

    public modalidadeGarantia: string;

    constructor(protected injector: Injector,
                private cancelamentoService: SolicitacaoCancelamentoGarantiaService,
                private recuperacaoService: RecuperacaoCreditoService,
                private permissaoService: PermissaoService,
                private modalService: BnModalMessageService,
                private loadingService: BnLoadingService,
                private activatedRoute: ActivatedRoute,
                private dataSistemService: DataSistemaService,
                private modalidadeService: ModalidadeService
                ) {

        super(cancelamentoService, new BaseEntityConfig('/cancelamento'));
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.config.rotaLista = '/cancelamento/pesquisa';
        dataSistemService.getDataCorrente().subscribe(data =>  {
            this.dataCorrente = data;
            console.log("data corrente capturada do back: " + this.dataCorrente);
        }
        );
    }

    ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.permissaoLinkN03 = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
            this.podeAprovarOuReprovar = resp && (resp[ROLE_GESTOR_ENVIO]);
            this.podeCancelar = resp && (resp[ROLE_AGENTE_ENVIO] || resp[ROLE_GESTOR_ENVIO]);
        });
        this.route.params.subscribe(params => {
            this.idSolicitacaoCancelamento = params['id'];
            this.cancelamentoService.getSolicitacaoCancelamento(this.idSolicitacaoCancelamento).subscribe(resp => {
                this.solicitacaoCancelamento = resp;
            });
        });

        this.modalidadeService.modalidade$.subscribe((modalidade) => {
            this.modalidadeGarantia = modalidade;
          });
    }

    executarAcao(opcao: Acao) { 

        if (opcao == 'aprovar') {
            this.calcularValorHonradoARecuperar().subscribe((resp) => {
                this.valorHistoricoHonra = resp.valorHonraHistorico;
                this.valorHonradoARecuperar = resp.valorHonradoARecuperarAtualizado;        
                this.valorBaseCalculoMulta = this.solicitacaoCancelamento.valorBaseCalculoMulta;
                this.valorPercentualMulta = this.solicitacaoCancelamento.valorPercentualMulta;

                if ((this.valorBaseCalculoMulta == 0 && this.valorHonradoARecuperar > 0) || this.valorHonradoARecuperar == this.valorBaseCalculoMulta) {
                    this.radioBaseCalculo = "valorHonradoARecuperar";
                } else if (this.valorHistoricoHonra == this.valorBaseCalculoMulta) {
                    this.radioBaseCalculo = "valorHistoricoHonra";
                }

                this.trocaOpcaoBaseMulta(null);
               
                this.abrirModalConfirmacao('aprovar');
            }, error => {
                console.log(error);
                this.ocorrencias = this.recuperacaoService.ocorrencias;
                this.loadingService.liberaTela();
            });
        } else  {
            this.abrirModalConfirmacao(opcao);
        }
    }

    abrirModalConfirmacao(acaoEscolhida: Acao) {

        this.acaoEscolhida = acaoEscolhida;

        this.motivoReprovacao = '';
        
        let titulo;
        let template;
        let acaoExecutada;

        if (acaoEscolhida == "aprovar") {
            titulo = 'Aprovação do cancelamento';
            template = this.mensagemAprovacao;
            acaoExecutada = "aprovada";
        } else if (acaoEscolhida == "reprovar") {
            titulo = 'Reprovação do cancelamento';
            template = this.mensagemReprovacao;
            acaoExecutada = "reprovada";
        } else {
            titulo = 'Reversão do cancelamento'
            template = this.mensagemReversao;
            acaoExecutada = "revertida";
        }

        this.modalService
            .abrir(titulo, null, 'lg', template, this.botoesDeAcao)
            .result
            .then((solicitacao: SolicitacaoCancelamentoGarantia) => {
                this.solicitacaoCancelamento = solicitacao;

                this.messageService.addMessage({
                    title: 'Sucesso',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.SUCCESS,
                    message: 'Solicitação de cancelamento de garantia ' + acaoExecutada +' com sucesso.'
                });
                this.ocorrencias = [];
            }, (reason) => {
                console.log(reason);
            });
    }

    confirmarAcao() {
        this.loadingService.bloqueiaTela();

        let multa = new MultaCancelamento();
        multa.valorBaseCalculoMulta = this.valorBaseCalculoMulta;
        multa.valorPercentualMulta = this.valorPercentualMulta;

        let acao;
        
        if (this.acaoEscolhida == "aprovar") {
            acao = this.cancelamentoService.aprovarSolicitacaoCancelamento(this.idSolicitacaoCancelamento,multa);
        } else  if (this.acaoEscolhida == "reprovar") {
            acao = this.cancelamentoService.reprovarSolicitacaoCancelamento(this.idSolicitacaoCancelamento, this.motivoReprovacao);
        } else {
            acao = this.cancelamentoService.reverterSolicitacaoCancelamento(this.idSolicitacaoCancelamento, this.motivoReversao);
        }      
        
        this.ocorrencias = [];

        acao.subscribe(solicitacaoCancelamento => {
            this.modalService.close(solicitacaoCancelamento);
            this.loadingService.liberaTela();
        }, error => {
            console.log(error);
            this.ocorrencias = this.cancelamentoService.ocorrencias;
            this.loadingService.liberaTela();
        });
    }

    calcularValorHonradoARecuperar(): Observable<ResultadoCalculoValorHonradoARecuperar> {
        let params: any = {};
        params.cnpjAgenteFinanceiro = this.solicitacaoCancelamento?.cnpjAgenteFinanceiro.trim();
        params.dataReferencia = moment(this.dataCorrente).format('YYYYMMDD');
        
        params.sistema = this.solicitacaoCancelamento.sistemaRepasse ? 
            this.solicitacaoCancelamento?.sistemaRepasse : "CL";
      
        if (this.solicitacaoCancelamento.idOperacaoExterno) {
            params.idExternoOperacao = this.solicitacaoCancelamento?.idOperacaoExterno
        }
        if (this.solicitacaoCancelamento.contratoRepasse) {
            params.contrato = this.solicitacaoCancelamento.contratoRepasse;
        }        
        
        return this.recuperacaoService.calcularValorHonradoRecuperar(params);
    }

    trocaOpcaoBaseMulta(evento) {
        if (this.radioBaseCalculo === "valorHonradoARecuperar") {
           this.valorBaseCalculoMulta = this.valorHonradoARecuperar;
        } else {
            this.valorBaseCalculoMulta = this.valorHistoricoHonra;
        }
    }

    cancelarAcao() {
        this.modalService.dismiss('abortou aprovacao/reprovação/reversao');

        this.valorHistoricoHonra = null;
        this.valorHonradoARecuperar = null;      
        this.valorPercentualMulta = null;
        this.valorBaseCalculoMulta = null;
        this.radioBaseCalculo = null;
    }

    private nomeAgente(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    private mesAno(valor?: string): string {
        return Utils.mesAno(valor);
    }

    obterDescricaoMotivoCancelamento(solicitacaoCancelamento : SolicitacaoCancelamentoGarantia) {
        return MOTIVO_CANCELAMENTO.find(m => m.codigo == solicitacaoCancelamento.ideMotivoSolicitacaoCancelamento)?.nome;
    }
    
    ajustaCampoDate(data:any) {
        if (typeof data === 'string') {
          if (data.length == 10) {
            data += ' 00:00:00';
          }
          return new Date(data);
        }
    
        return data;
      }
}
